export const DELIVERY_STATUS_DRAFT = "DRAFT";
export const DELIVERY_STATUS_CANCELED = "CANCELED";
export const DELIVERY_STATUS_VALIDATED = "VALIDATED";

export const deliveriesStatusesOption = {
  [DELIVERY_STATUS_DRAFT]: "Brouillon",
  [DELIVERY_STATUS_CANCELED]: "Annulée",
  [DELIVERY_STATUS_VALIDATED]: "Validée",
};
